module.exports = __webpack_public_path__ + "static/media/neutral-face-svgrepo-com.dc105de7.svg";